import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import { userInfo } from '@/__mocks__/modules/loggedUser/data.ts'

export default [
  {
    method: 'GET',
    path: `/user-info`,
    reply: async () => {
      await wait()
      return [status.ok, userInfo]
    }
  },
  {
    method: 'POST',
    path: `/users/2/link-document`,
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
